import React from 'react';
import {BrowserRouter as Router, Switch, Route } from 'react-router-dom'

import Homepage from '../HomePage'
import CertificatePage from '../../components/CertificatePage'

const AllRoute = () => { 

  return (
    <div className="App">
       <Router>
          <Switch>
            <Route exact path='/' component={Homepage} />
            <Route path='/home' component={Homepage} />
            <Route path='/certificates' component={CertificatePage} />
          </Switch>
      </Router>
      
    </div>
  );
}

export default AllRoute;
